import MadeBy from './MadeBy';

export default MadeBy;